<template>
    <div class="card">
        <div class="hd">
            <span class="name">{{ cardInfo.userName }}</span>
            <span class="sex">{{ cardInfo.sex == 1 ? '男' : '女' }}</span>
            <span class="sex">{{ cardInfo.age }}岁</span>
            <span class="time">{{ cardInfo.createTime }}</span>
        </div>
        <div style="height: 5px;"></div>
        <div style="display: flex; flex-wrap: nowrap; width: 100%; overflow: hidden;">
            <span class="medicine">{{ drugText}}</span>
        </div>
        <div style="height: 5px;"></div>
        <div class="border"></div>
        <div class="footer">
            <van-button class="footer_button" ound type="default" @click="deleteClick">删除</van-button>
            <van-button class="footer_button" :loading="btnLoading" ound type="primary"
                @click="goInquiry">去问诊</van-button>
        </div>
    </div>
</template>
<script>
import { Dialog,Toast } from 'vant'
import {
    checkIfOpen,
    physicanStatus,
    checkBtermInquiryPermission,
} from '../../../api/index'
import { getCookie } from '@/utils/auth'
export default {
    props: {
        cardInfo: {
            type: Object,
            default: {}
        },
        thirdPlatformSource:{
            type: Number,
        },
        thirdPartyPlatformName:{
            type: String,
            default: ''
        }
    },
    data() {
        return {
            organSign: '',
            btnLoading: false,

        }
    },
    computed: {
        drugText() {
            let arr  = this.cardInfo.drugList.map((e) => e.commonName) || []
            return arr.join(' / ')
        }
    },
    watch: {

    },
    beforeDestroy() {
    },
    created() {
        const client = getCookie('native_client') || ''
        if (client === 'android' || client === 'ios' || client === 'pad') {
            this.organSign = getCookie('native_organSign')
        } else {
            this.organSign = getCookie('organSign')
        }
    },
    methods: {
        deleteClick() {
            Dialog.confirm({
                title: '提示',
                message: `您确定要删除此待问诊信息吗？删除后如需再问诊，可在${this.thirdPartyPlatformName}侧重新发起。`,
            }).then(() => {
                this.$emit('deleteFn', this.cardInfo)
            }).catch(() => {
            });
        },
        async goInquiry() {
            this.btnLoading = true;
            var permission = await checkBtermInquiryPermission({ organSign: this.organSign });
            if (permission.data.code === 0) {
                if (!permission.data.result.passable) {
                    this.btnLoading = false;
                    return Toast(permission.data.result.tipMessage);
                }
            } else {
                this.btnLoading = false;
                return Toast(permission.data.msg);
            }
            localStorage.removeItem('params')
            try {
                physicanStatus({ organSign: this.organSign }).then(res => {
                    if (res.data.code === 0) {
                        // 1-有医生在线；0-无医生在线；
                        if (res.data.result.doctorOnlineState) {
                            checkIfOpen({ organSign: this.organSign }).then(res => {
                                if (res.result !== false) {
                                    localStorage.setItem('sourceId',this.thirdPlatformSource)
                                    this.$router.push({
                                      path: 'interrogationInfoText',
                                      query: { thirdPartyPrePrescriptionId:  this.cardInfo.id}
                                    })
                                } else {
                                    Toast(
                                        '您还未开通远程处方服务，如需开通请联系客服电话400-0919-990'
                                    )
                                }
                            })
                        } else {
                            Toast(this.res.data.result.desc)
                        }
                    } else {
                        Toast(this.res.data.result.desc)
                    }
                })
            } catch (err) {
                this.setLog({
                    message: '获取医生状态接口异常',
                    type: '/home'
                })
                console.log('err', err)
            }
            this.btnLoading = false;
        }
    }
}
</script>
<style scoped lang="scss">
.card {
    width: 100%;
    background: #FFFFFF;
    border-radius: 5px;
    margin-bottom: 10px;
    padding: 15px 10px 8px;
    box-sizing: border-box;
}

.hd {
    display: flex;
    align-items: center;

    .name {
        max-width: 140px;
        font-weight: 500;
        font-size: 16px;
        color: #333333;
        letter-spacing: 0;
        word-break: break-all;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
    }

    .sex {
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        letter-spacing: 0;
        margin-left: 5px;
    }

    .time {
        font-weight: 400;
        font-size: 12px;
        color: #9D9FB8;
        letter-spacing: 0;
        text-align: right;
        margin-left: auto;
    }
}

.medicine {
    width: 100%;
    font-weight: 400;
    font-size: 12px;
    color: #666883;
    letter-spacing: 0;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
}

.border {
    border-bottom: 1px solid #EEEEEE;
}

.footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 5px;

    .footer_button {
        width: 80px;
        height: 26px;
        border-radius: 13px;
    }
}

.footer button:nth-child(2) {
    margin-left: 15px;
}
</style>